/**
 * Who reaches which Company Settings page. Admins reach all of it; project managers only the
 * pages the server opens to them (EnsureCompanyManager: Email Signature, 17 Oct 2026). Hiding a
 * page restricts nothing, the server refuses on its own; this only decides what is worth showing.
 */
export const MANAGER_PAGES = ['/company/signature']

/** 'admin', 'manager' or null, for the company the person is working in. */
export function companySettingsAccess(user, companyId) {
    if (!user) return null
    if (user.is_super_admin || (user.admin_company_ids ?? []).includes(companyId)) return 'admin'
    if ((user.manages_company_ids ?? []).includes(companyId)) return 'manager'
    return null
}

export function visibleCompanyNav(items, access) {
    if (access === 'admin') return items
    if (access === 'manager') return items.filter(i => MANAGER_PAGES.includes(i.route))
    return []
}

export function companySettingsHome(access) {
    return access === 'admin' ? '/company/information' : '/company/signature'
}
